export default [{
  label: 'Razão social', field: 'razaoSocial', type: 'custom',
},
{ label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'tamanho-cnpj' },
{ label: 'Receita Bruta do PA (RPA) - Competência', field: 'rpa', tdClass: 'col-2 text-right' },
{ label: 'Receita bruta acumulada nos doze meses anteriores ao PA (RBT12)', field: 'rbt12', tdClass: 'col-2 text-right' },
{ label: 'Receita bruta acumulada no ano-calendário corrente (RBA)', field: 'rba', tdClass: 'col-2 text-right' },
{
  label: '3.600.000,00 % Sublimite', field: 'rbaSublimite', tdClass: 'col-tamanho-situacao text-center', type: 'custom',
},
{
  label: '4.800.000,00 % Limite', field: 'rbaLimite', tdClass: 'col-tamanho-situacao text-center', type: 'custom',
},
{ label: 'Competência', field: 'competencia' },
{ label: 'Consultado em', field: 'consultadoEm' }]
